const a = (e) => {
  const o = localStorage.getItem("editorItems");
  if (!o)
    return null;
  let t = JSON.parse(o);
  if (!t.length)
    return null;
  const s = Date.now();
  t = t.filter(({ id: n, timestamp: r }) => r * 1 + e * 1e3 < s ? (localStorage.removeItem(n), !1) : !0);
  const c = JSON.stringify(t);
  o !== c && localStorage.setItem("editorItems", c);
}, l = (e) => {
  const o = localStorage.getItem(`content_${e}`), t = localStorage.getItem(`sides_${e}`);
  return t && o ? { content: o, sides: JSON.parse(t) } : null;
}, m = (e, o) => {
  const t = localStorage.getItem("editorItems"), s = t ? JSON.parse(t) : [], c = s.findIndex((n) => n.id === e);
  c !== -1 && s.splice(c, 1), s.push({ id: e, timestamp: Date.now() }), localStorage.setItem("editorItems", JSON.stringify(s)), localStorage.setItem(`content_${e}`, o.content), localStorage.setItem(`sides_${e}`, JSON.stringify(o.sides));
}, i = (e) => {
  localStorage.removeItem(`content_${e}`), localStorage.removeItem(`sides_${e}`);
}, g = {
  check: a,
  get: l,
  set: m,
  delete: i
};
export {
  g as default
};
